import { useAuthStore } from "../../stores/authStore";

// Shown while a session is still held. Login renders the same store error
// when boot never produced a session.
export function ReachabilityNote() {
  const error = useAuthStore((s) => s.error);
  if (!error) return null;
  return (
    <p
      role="status"
      className="border-b border-line bg-surface px-4 py-1 text-xs text-red-400"
    >
      {error}
    </p>
  );
}
